import { Button } from '@edsn/pie-components';
import IconMail from '@iconify/icons-material-symbols/mail-outline';
import { Link } from 'react-router';
import { Card } from '#pie/components/card/Card';
import { Text } from '#pie/components/text/Text';
import { CopyButton } from '../copy-button/CopyButton';
import { Icon } from '../icon/Icon';

interface SupportCardProps {
  buttonText: string;
  buttonType?: 'button' | 'link';
  description: string;
  heading: string;
  href: string;
  target?: '_blank' | '_self' | '_parent' | '_top';
}

export const SupportCard = ({
  buttonText,
  buttonType,
  description,
  heading,
  href,
  target,
}: SupportCardProps) => {
  return (
    <Card size="md" className="flex h-full flex-col">
      {buttonType ? (
        <div className="flex h-full flex-col">
          <Text as="h2" variant="h6" className="mb-4">
            {heading}
          </Text>
          <Text className="grow">{description}</Text>
          {buttonType === 'button' ? (
            <div className="mt-auto pt-4">
              <Button
                as="a"
                href={href}
                action="secondary"
                emphasis="bold"
                className="size-fit"
              >
                {buttonText}
              </Button>
            </div>
          ) : (
            buttonType === 'link' && (
              <div className="mt-auto flex items-center gap-2 pt-4">
                <Icon
                  size={16}
                  icon={IconMail}
                  className="text-action-secondary-enabled"
                />
                <CopyButton content={buttonText} className="relative size-fit">
                  <Link to={href} className="text-action-secondary-enabled">
                    {buttonText}
                  </Link>
                </CopyButton>
              </div>
            )
          )}
        </div>
      ) : (
        <div className="flex h-full flex-col">
          <Text as="h2" variant="h6" className="mb-4">
            {heading}
          </Text>
          <Text className="grow">{description}</Text>
          <div className="mt-auto pt-4">
            <Link
              to={href}
              target={target}
              className="text-action-secondary-enabled"
            >
              {buttonText}
            </Link>
          </div>
        </div>
      )}
    </Card>
  );
};
